"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUsersItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUsersItem, _Component);

  function ProjectUsersItem(props) {
    (0, _classCallCheck3.default)(this, ProjectUsersItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectUsersItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectUsersItem)).call(this, props));

    _this.removeItem = function (event) {
      event.preventDefault();
      _this.props.removeProjectUser(_this.props.item);
    };

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.updateQuantity = _this.updateQuantity.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);

    _this.state = {
      is_project_editor: false,
      is_driver: false,
      is_admin: false
    };
    return _this;
  }

  (0, _createClass3.default)(ProjectUsersItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var item = this.props.item;

      this.setState({
        is_project_editor: item.is_project_editor,
        is_driver: item.is_driver,
        is_admin: item.is_admin
      });
    }
  }, {
    key: "render",
    value: function render() {
      var item = this.props.item;
      var quantity = this.state.quantity;


      return _react2.default.createElement(
        "tr",
        { className: "project-user-item", key: item.id },
        _react2.default.createElement(
          "td",
          { className: "project-user-checkbox" },
          _react2.default.createElement(
            "div",
            { className: "checkbox-single" },
            _react2.default.createElement("input", {
              name: "is_admin",
              type: "checkbox",
              checked: this.state.is_admin,
              onChange: this.handleInputChange })
          )
        ),
        _react2.default.createElement(
          "td",
          { className: "project-user-checkbox" },
          _react2.default.createElement(
            "div",
            { className: "checkbox-single" },
            _react2.default.createElement("input", {
              name: "is_project_editor",
              type: "checkbox",
              checked: this.state.is_project_editor,
              onChange: this.handleInputChange })
          )
        ),
        _react2.default.createElement(
          "td",
          { className: "cart-item-price" },
          item.email
        )
      );
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(event) {
      event.preventDefault();
      this.setState({ quantity: event.target.value });
    }
  }, {
    key: "removeProjectUser",
    value: function removeProjectUser() {}
  }, {
    key: "updateByEmail",
    value: function updateByEmail(data) {
      var updateProjectUserByEmail = this.props.updateProjectUserByEmail;

      updateProjectUserByEmail(data);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var isAdmin = this.props.isAdmin;


      if (isAdmin) {
        var target = event.target;
        var value = target.type === "checkbox" ? target.checked : target.value;
        var name = target.name;
        this.setState((0, _defineProperty3.default)({}, name, value));

        var newData = this.props.item;
        newData[target.name] = target.checked;

        if (this.props.item.id) {
          this.updateByEmail(newData);
        } else {
          this.updateByEmail(newData);
        }
      } else {
        alert("vain admin voi muuttaa käyttöoikeuksia");
        event.preventDefault();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      event.preventDefault();
      var quantity = parseInt(event.target.value, 10);
      if (isNaN(quantity) || quantity <= 0) {
        quantity = 1;
      }
      this.setState({ quantity: quantity });
      this.props.updateQuantity(this.props.item, quantity);
    }
  }]);
  return ProjectUsersItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object.isRequired,
  updateProjectUserByEmail: _react.PropTypes.func.isRequired,
  isAdmin: _react.PropTypes.bool.isRequired

}, _temp);
exports.default = ProjectUsersItem;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectUsersItem.js
 ** module id = 1179
 ** module chunks = 0
 **/